import { createStyles } from "src/styles/theme";

export type StylesClasses = keyof typeof styles;

const styles = createStyles({
  wrapper: {
    display: "flex",
    flexDirection: "column",
    backgroundColor: "#EBFAF8",
    borderWidth: "1px",
    borderStyle: "solid",
    borderColor: "custom.greyish.6",
    padding: "25px",
  },
  heading: {
    fontSize: "20px",
    fontWeight: 500,
    textTransform: "uppercase",
    color: "black",
    margin: "0 0 6px 0",
  },
  subHeading: {
    fontSize: "14px",
    fontWeight: 400,
    color: "custom.text.dark",
    opacity: 0.6,
    marginBottom: "20px",
  },
  entryList: {
    display: "flex",
    flexDirection: "column",
    gap: "14px",
  },
  entry: {
    backgroundColor: "#FFFFFF",
    border: "1px solid",
    borderColor: "custom.greyish.6",
    borderRadius: "12px",
    padding: "16px 20px",
  },
  entryHeader: {
    display: "flex",
    flexDirection: { xs: "column", md: "row" },
    justifyContent: "space-between",
    gap: "8px",
    marginBottom: "10px",
  },
  action: {
    fontSize: "16px",
    fontWeight: 600,
    color: "#36B1A0",
  },
  timestamp: {
    fontSize: "14px",
    fontWeight: 400,
    color: "custom.text.dark",
    opacity: 0.6,
  },
  actor: {
    fontSize: "14px",
    fontWeight: 400,
    color: "custom.text.dark",
    marginBottom: "10px",
  },
  changeRow: {
    display: "flex",
    flexDirection: { xs: "column", sm: "row" },
    alignItems: { xs: "flex-start", sm: "center" },
    gap: "8px",
    fontSize: "14px",
    padding: "4px 0",
  },
  changeLabel: {
    fontWeight: 600,
    minWidth: "140px",
  },
  oldValue: {
    textDecoration: "line-through",
    opacity: 0.6,
    wordBreak: "break-word",
  },
  arrow: {
    opacity: 0.6,
  },
  newValue: {
    fontWeight: 500,
    wordBreak: "break-word",
  },
  emptyState: {
    fontSize: "14px",
    color: "custom.text.dark",
    opacity: 0.6,
    padding: "20px 0",
    textAlign: "center",
  },
});

export default styles;
